import {
  formatNormalNumber,
  createKpiTileItem,
  formatPercentageValue,
} from '../../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { buWithActiveCycles, buWithActiveCyclesDelta } =
      data.getPOReachMetrics;

    return createKpiTileItem(
      "BU's with Active Cycles",
      formatNormalNumber(buWithActiveCycles),
      buWithActiveCyclesDelta !== null && buWithActiveCyclesDelta !== undefined
        ? {
            isPositiveValue: buWithActiveCyclesDelta >= 0,
            text: formatPercentageValue(Math.abs(buWithActiveCyclesDelta)),
            sideLabel: '',
            showArrow: Number(buWithActiveCyclesDelta) !== 0,
          }
        : null
    );
  },
};
